import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';


@Injectable({
    providedIn: 'root'
})
export class ReportingDirectionService{

    constructor(
        private http: HttpClient, 
        private _restClientService : RestClientService
        ) 
    {}
    
    exportDossiersEncoursByDirection(debut: String, fin: String, direction: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-direction/export-dossier-en-cours-by-direction?debut='+debut+'&fin='+fin+'&direction='+direction;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
    exportDossiersValideByDirection(debut: String, fin: String, direction: String): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+'reporting-direction/export-dossier-valide-by-direction?debut='+debut+'&fin='+fin+'&direction='+direction;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
  
}